<template>
  <div v-frag>
    <CardIeaAppMain>
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <CardIeaApp colorCard="#A7BA38" title="Ingresar">
          <v-form ref="form" v-model="valid" lazy-validation @submit="login()">
            <v-row align="center">
              <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[0]" />
              </v-col>
              <v-col cols="12" sm="12" xs="12" md="6" lg="6" xl="6">
                <InputCustom :inputProp="inputs[1]" />
              </v-col>
            </v-row>
          </v-form>
        </CardIeaApp>
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-btn
          @click="login()"
          block
          x-large
          class="white--text rounded-lg font-weight-regular"
          depressed
          color="btnSuccess"
          :disabled="!valid"
          :loading="loader"
          >Ingresar</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <v-btn
          @click="olvidoPass()"
          block
          x-large
          class="grey--text text-decoration-underline font-weight-regular"
          depressed
          text
          color="#FFFFFF"
          :disabled="!valid"
          :loading="loader"
          >Olvíde mi contraseña</v-btn
        >
      </v-col>
      <br /><br /><br /><br /><br />
      <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6"></v-col>
    </CardIeaAppMain>
  </div>
</template>

<script>
// @ is an alias to /src
import CardIeaApp from "../components/CardIeaApp";
import CardIeaAppMain from "../components/CardIeaAppMain";
import InputCustom from "../components/InputCustom";
import MessagesRules from "../config/MessagesRules";
export default {
  name: "Login",
  components: {
    CardIeaApp,
    InputCustom,
    CardIeaAppMain
  },
  computed: {
    loader() {
      return this.$store.getters.loader;
    }
  },
  data: () => ({
    valid: true,
    inputs: [
      {
        tag: "email",
        text: "Usuario",
        placeholder: "",
        icon: "mdi-account",
        required: true,
        value: "",
        type: "text",
        rules: [v => !!v || "Usuario" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "password",
        text: "Contraseña",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "",
        type: "password",
        rules: [v => !!v || "Contraseña" + MessagesRules.required],
        counter: 0
      },
      {
        tag: "web",
        text: "web",
        placeholder: "",
        icon: "mdi-lock",
        required: true,
        value: "true",
        type: "hidden",
        counter: 0
      },
      
    ]
  }),
  methods: {
    async login() {
      let that = this;
      if (this.$refs.form.validate()) {
        await this.$API
          .post({
            url: "profesor/login",
            data: that.inputs,
            form: true
          })
          .then(res => {
            console.log(res);
            that.$store.dispatch(
              "token",
              res.token_type + " " + res.access_token
            );
            that.$store.dispatch("user", {
              IDStB: res.user.id,
              Nombres: res.user.usu_nombre,
              docente: res.user.docentes,
              puntaje : res.user.puntaje,
              vendedor : res.user.vendedor,
              email : res.user.email,
              cobrador : res.user.cobrador,
            });
            setTimeout(() => {
              that.$router.replace({ name: "Home" });
            }, 2000);
          });
      }
    },
    async olvidoPass() {
      this.$router.replace({ name: "ResetPassword" });
    }
  }
};
</script>
